import "./Cards.css";
import { data } from "./data";
import Cards from "./Cards";
import Certificate from "./Certifications";
export default function Skills() {
  return (
    <>
      <div className="skills-container">
        {data.map((item) => {
          return <Cards img={item.img} des={item.des} />;
        })}
      </div>
      <Certificate />
    </>
  );
}
